Object.defineProperty(exports,"__esModule",{value:true});exports.ViewPropTypes=undefined;var _viewPropTypes=require('./viewPropTypes');var _viewPropTypes2=_interopRequireDefault(_viewPropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.

ViewPropTypes=_viewPropTypes2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/Utils/index.js
// module id = 7
// module chunks = 0